import './Skeleton.css';

export function SkeletonBox({ width = '100%', height = 16, borderRadius = 4, style = {} }) {
  return (
    <div
      className="skeleton-box"
      style={{ width, height, borderRadius, ...style }}
    />
  );
}

export function SkeletonVideoCard() {
  return (
    <div className="skeleton-video-card">
      <SkeletonBox height={140} borderRadius={6} />
      <SkeletonBox height={14} style={{ marginTop: 8 }} />
      <SkeletonBox width="60%" height={12} style={{ marginTop: 6 }} />
    </div>
  );
}

export function SkeletonEventCard() {
  return (
    <div className="skeleton-event-card">
      <SkeletonBox height={160} borderRadius={6} />
      <div style={{ padding: '10px 0' }}>
        <SkeletonBox width="40%" height={12} style={{ marginBottom: 8 }} />
        <SkeletonBox height={16} style={{ marginBottom: 6 }} />
        <SkeletonBox width="70%" height={12} style={{ marginBottom: 10 }} />
        <SkeletonBox width="50%" height={12} />
      </div>
    </div>
  );
}

export function SkeletonCountryBtn() {
  return (
    <div className="skeleton-country-btn">
      <SkeletonBox width={32} height={22} borderRadius={2} />
      <SkeletonBox width={80} height={12} borderRadius={3} />
    </div>
  );
}

export function SkeletonRepDetail() {
  return (
    <div style={{ padding: '20px 0' }}>
      <SkeletonBox width="50%" height={24} style={{ marginBottom: 20 }} />
      {[1, 2, 3, 4].map(i => (
        <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
          <SkeletonBox width={180} height={13} />
          <SkeletonBox width="60%" height={13} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonChannelItem() {
  return (
    <div className="skeleton-channel-item">
      <SkeletonBox width={40} height={40} borderRadius="50%" />
      <div style={{ flex: 1 }}>
        <SkeletonBox width="70%" height={14} style={{ marginBottom: 6 }} />
        <SkeletonBox width="50%" height={11} />
      </div>
      <SkeletonBox width={80} height={30} borderRadius={4} />
    </div>
  );
}
